import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { getWhyApplyStoryForCondition } from '@modules/patientTrialApplications/helpers/getWhyApplyStoryForCondition'

const TrialCardRevamped = ({
  condition,
  trialTitle,
}: {
  condition: string
  trialTitle: string
}) => {
  const userStory = getWhyApplyStoryForCondition({
    conditionName: condition,
  })

  return (
    <div className='relative hidden lg:block'>
      {/* Top Gradient */}
      <div className='pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-white/80 to-transparent'></div>
      {/* Bottom Gradient */}
      <div className='pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white/70 to-transparent'></div>

      <div className='absolute top-4 z-10 mx-4 text-3xl font-extrabold text-white'>
        {trialTitle}
      </div>

      <div className='absolute bottom-32 flex justify-center xl:bottom-2'>
        <div className='w-[90%] rounded-lg border border-white/25 bg-black/25 p-2 text-white backdrop-blur-lg'>
          <p className='mb-3 text-xs font-bold text-white/90'>
            {userStory.whyApplyStory}
          </p>

          <p className='text-xs font-bold'>{userStory.whyApplyPatientName}</p>
          <p className='text-xs'>
            {userStory.whyApplyPatientAge}, {userStory.whyApplyPatientAddress}
          </p>
        </div>
      </div>
      <CloudflareImage
        alt={trialTitle}
        className='rounded-3xl'
        imageId='87276deb-26f9-4523-8f39-cf2152e1f000'
        width={370}
      />
    </div>
  )
}

export default TrialCardRevamped
